import type { RealtimeToken } from '@soniox/client'

function isSourceToken(token: RealtimeToken): boolean {
  return token.translation_status !== 'translation' && token.text !== '<end>'
}

export function tokensToPlainTranscript(tokens: readonly RealtimeToken[]): string {
  return tokens
    .filter((token) => token.is_final && isSourceToken(token))
    .map((token) => String(token.text ?? ''))
    .join('')
    .replace(/<end>/g, '')
    .trim()
}
